import Instance from '../../../Axios';

// New Actions for the app

const GetProdutos = () => async (dispatch) => {
  await Instance()
    .get(`/backend/produtos`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_PRODUTOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetProdutos;
